import { render, staticRenderFns } from "./uploadmore.vue?vue&type=template&id=2310e91d&"
import script from "./uploadmore.vue?vue&type=script&lang=js&"
export * from "./uploadmore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports